import Phaser from "phaser";
// import Boot from "./scenes/Boot";
import Preload from "./scenes/Preload";
import Start from "./scenes/Start";
import Easy from "./scenes/Easy";
import Instructions from "./scenes/Instructions";
import { data } from "./data";
import Medium from "./scenes/Medium";
import Hard from "./scenes/Hard";
import Slot from "./scenes/Slot";

let allData = data();
new Phaser.Game({
  type: Phaser.WEBGL,
  width: allData.width * window.devicePixelRatio, 
  height: allData.height * window.devicePixelRatio,
  canvas: document.getElementById("canvas"),
  physics: {
    default: "arcade",
    arcade: {
      gravity: { y: 0 },
      fps: 120,
      // debug: true,
    },
  },
  scene: [Start, Preload, Instructions, Easy, Medium, Hard, Slot],
});
